// extracted by mini-css-extract-plugin
var _1 = "add-field____HytL";
var _2 = "add-field-affix___Snork";
var _3 = "add-field-wrapper____EPUK";
var _4 = "create-record-table___D1kwS";
var _5 = "enter-icon___XrtPq";
var _6 = "field-error___DaZW0";
var _7 = "table-cell-input___XfOGP";
export { _1 as "add-field", _2 as "add-field-affix", _3 as "add-field-wrapper", _4 as "create-record-table", _5 as "enter-icon", _6 as "field-error", _7 as "table-cell-input" }
